import { css } from 'emotion';

export const section = css`
	padding-bottom: 1em;
	font-size: 1.2em;
	font-weight: normal;
`;

export const commandLabel = css`
	padding-bottom: 1.4em;
	font-size: 1.2em;
	cursor: pointer;
`;

export const pre = css`
	overflow-x: auto !important;
	white-space: pre-wrap !important;
	white-space: -moz-pre-wrap !important;
	white-space: -pre-wrap !important;
	white-space: -o-pre-wrap !important;
	word-wrap: break-word !important;
`;

export const lbl = css`
	font-size: 1.2em !important;
	font-weight: normal !important;
`;



// WEBPACK FOOTER //
// ./src/routes/Manager/Playground/styles.js